import type { ClientBasedAuth } from '@atlaskit/media-core/auth';
import { ObjectRecorder } from '../src/ObjectRecorder.ts';

export const mediaConfigRecorder = new ObjectRecorder<ClientBasedAuth>();
export const jiraMediaConfigRecorder = new ObjectRecorder<ClientBasedAuth>();
export const mediaConfigEnforceDSPRecorder = new ObjectRecorder<boolean>();
